import { useContext, useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import MailIcon from '@mui/icons-material/Mail';
import { Modal, Box } from '@mui/material';
import IosShareIcon from '@mui/icons-material/IosShare';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import CircularLoader from './common/Loader';
import { API_URI, END_POINTS } from './Constants';
import CircularProgress from '@mui/material/CircularProgress';
import Dropdown from './Dropdown';
import { Button } from '@mui/material';
import { CandidateContext } from './Context';
import { Menu, MenuItem } from '@mui/material';
import EditableField from './common/EditCtcs';
import InterviewComponent from './common/PanelistNameEMail';
import SnackbarComponent from './common/Snackbar';
import { Close as CloseIcon } from "@mui/icons-material";
import WorkIcon from '@mui/icons-material/Work';
import SchoolIcon from '@mui/icons-material/School';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import PersonIcon from '@mui/icons-material/Person';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import {
  Typography,
  IconButton, 
  Backdrop,
  Card,
  CardContent,
  Chip,
  Avatar
} from "@mui/material";
import { useParams } from 'react-router-dom';
import axiosInstance from '../Api/Instance';
import { useSelector } from 'react-redux';
import FormattedResumeModal from '../components/common/FormattedResumeModal';
export default function CandidateProfile() {
  const { application_status, applied_position, isEditRemarksOpen, setIsEditRemarksOpen, setApplied_position, setApplication_status } = useContext(CandidateContext);
  const { id: candidateID } = useParams();
  const [candidate, setCandidate] = useState([]);
  const [isStatusClose, setIsStatusClose] = useState(true);
  const [statusLoader, setStatusLoader] = useState(false);
  const [roleLoader, setRoleLoader] = useState(false);
  const [remarksLoader, setRemarksLoader] = useState(false);
  const [isRoleClose, setIsRoleClose] = useState(true)
  const navigate = useNavigate();
  // const skills = candidate?.skills || [];
  const [status, setStatus] = useState(candidate?.status);
  const [role, setRole] = useState(candidate?.applied_position);
  const [isRemarksOpen, setIsRemarksOpen] = useState('');
  const [resume, setResume] = useState(candidate?.resume);
  const [formValue, setFormValue] = useState(candidate?.remarks || '');
  const [profileSummary, setProfileSummary] = useState(candidate?.profileSummary || 'N/A');
  //const [rolesArray, setRolesArray] = useState([]);
  const [errorSnackbar, setErrorSnackbar] = useState(false);
 
  const user = useSelector((state) => state.auth.user);
  const userId = user?._id;
  const isAdmin = user?.role ==='admin';
  const [isFormattedResumeOpen, setIsFormattedResumeOpen] = useState(false);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };
 const [resumeMenuAnchor, setResumeMenuAnchor] = useState(null);
const openResumeMenu = (e) => setResumeMenuAnchor(e.currentTarget);
const closeResumeMenu = () => setResumeMenuAnchor(null);

  const handleCloseLoader = () => setOpenLoader(false)
  const flattenSkills = (skillsData) => {
    if (!Array.isArray(skillsData)) return [];

    const flatSkills = [];

    skillsData.forEach((entry) => {
      if (typeof entry === "string") {
        flatSkills.push(entry);
      } else if (Array.isArray(entry)) {
        flatSkills.push(...entry);
      } else if (typeof entry === "object" && entry !== null) {
        Object.values(entry).forEach((val) => {
          if (Array.isArray(val)) {
            flatSkills.push(...val);
          } else if (typeof val === "string") {
            flatSkills.push(val);
          }
        });
      }
    });

    return flatSkills;
  };
  const skills = flattenSkills(candidate?.skills || []);
  const [currentCtc, setCurrentCtc] = useState({
    value: candidate?.currentCtc,
    isActive: false,
    isLoading: false
  });
  const [expectedCtc, setExpectedCtc] = useState({
    value: candidate?.expectedCtc || 'N/A',
    isActive: false,
    isLoading: false
  });
  const [currentName, setCurrentName] = useState({
    value: candidate?.name || 'N/A',
    isActive: false,
    isLoading: false
  })
  const [currentOrg, setCurrentOrg] = useState({
    value: candidate?.currentOrganisation || 'N/A',
    isActive: false,
    isLoading: false
  })
  const [noticePeriod, setNoticePeriod] = useState({
    value: candidate?.noticePeriod || 'N/A',
    isActive: false,
    isLoading: false
  })
  const [relocate, setRelocate] = useState({
    value: candidate?.relocate || 'N/A',
    isLoading: false,
    isActive: false
  })
  const [releventExp, setReleventExp] = useState({
    value: candidate?.releventExp || 'N/A',
    isActive: false,
    isLoading: false
  })
  const [currentExp, setCurrentExp] = useState({
    value: candidate?.currentExp || 'N/A',
    isActive: false,
    isLoading: false
  })
  const [currentLocation, setCurrentLocation] = useState({
    value: candidate?.location || 'N/A',
    isActive: false,
    isLoading: false
  })
  const [currentPhone, setCurrentPhone] = useState({
    value: candidate?.phone_number || 'N/A',
    isLoading: false,
    isActive: false
  })
  const [currentEducation, setCurrentEducation] = useState({
    value: candidate?.education || 'N/A',
    isLoading: false,
    isActive: false
  })
  const [currentEmail, setCurrentEmail] = useState({
    value: candidate?.email || 'N/A',
    isLoading: false,
    isActive: false
  })
  const [candidateReview, setCandidateReview] = useState({
    value: '',
    isLoading: false,
    isActive: false
  })
  const [activateMenu, setActivateMenu] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null);
  const [open, setOpen] = useState(false);
  const [isViewResume, setIsViewResume] = useState(false);
  const [pdfURL, setPdfURL] = useState('');
  const [openUploadFile, setOpenUploadFile] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [message, setMessage] = useState('🎉 Resume successfully shared with the panelist!')
  const [selectedFile, setSelectedFile] = useState(null);
  const [isCircularProgress, setIsCircularProgress] = useState(false);
  const [openLoader, setOpenLoader] = useState(false)
  const [alertInfo, setAlertInfo] = useState({ open: false, message: '', severity: 'info' });

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    setIsCircularProgress(true)
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("resume", selectedFile);

    try {
      const response = await axiosInstance.post(
        `${END_POINTS.RESUME_UPDATE}/${candidate._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        setResume(response.data.candidate.resume)
        setIsCircularProgress(false)
      } else {
        console.warn("Unexpected response status:", response.status);
      }

      setOpenUploadFile(false);
      setSelectedFile(null);
    } catch (error) {
      console.error("Failed to upload resume:", error);

      if (error.response) {
        alert(`Error: ${error.response?.data?.message || "Upload failed"}`);
      } else if (error?.request) {
        alert("Error: No response from server.");
      } else {
        alert("Error: Something went wrong while uploading.");
      }
    }
  };


  useEffect(() => {
    const fetchCandidate = async () => {
      setOpenLoader(true)
      try {

        const response = await axiosInstance.get(`${END_POINTS.CANDIDATE}/${candidateID}`);
        const updatedCandidate = response.data;

        setCandidate(updatedCandidate);
        setStatus(updatedCandidate.status || 'N/A');
        setRole(updatedCandidate.applied_position || 'N/A');
        setResume(updatedCandidate.resume || '');
        setFormValue(updatedCandidate.remarks || '');
        setProfileSummary(updatedCandidate.profileSummary || 'N/A');
        setCurrentName(prev => ({ ...prev, value: updatedCandidate.name || 'N/A' }));
        setExpectedCtc(prev => ({ ...prev, value: updatedCandidate.expectedCtc || 'N/A' }));
        setRelocate(prev => ({ ...prev, value: updatedCandidate.relocate || 'N/A' }));
        setCurrentCtc(prev => ({ ...prev, value: updatedCandidate.currentCtc || 'N/A' }));
        setCurrentLocation(prev => ({ ...prev, value: updatedCandidate.location || 'N/A' }));
        setCurrentPhone(prev => ({ ...prev, value: updatedCandidate.phone_number || 'N/A' }));
        setCurrentEducation(prev => ({ ...prev, value: updatedCandidate.education || 'N/A' }));
        setCurrentOrg(prev => ({ ...prev, value: updatedCandidate.currentOrganisation || 'N/A' }));
        setCurrentEmail(prev => ({ ...prev, value: updatedCandidate.email || 'N/A' }));
        setCurrentExp(prev => ({ ...prev, value: updatedCandidate.experience || 'N/A' }));
        setNoticePeriod(prev => ({ ...prev, value: updatedCandidate.noticePeriod || 'N/A' }));
        setReleventExp(prev => ({ ...prev, value: updatedCandidate.releventExp || 'N/A' }));
        setOpenLoader(false);
      } catch (err) {
        console.error("Error fetching candidate:", err);
        setOpenLoader(false)
      }
    };

    if (candidateID) {
      fetchCandidate();
    }
  }, [candidateID]);





  const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxHeight: '90vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 3,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  };

  const handleClose = (e) => {
    if (e.target.id === "changeStatus") {
      setIsStatusClose(false);
    }
    if (e.target.id === "changeRole") {
      setIsRoleClose(false);
    }
  }
  const openEmail = Boolean(anchorEl);

  const handleEmailClick = (event) => {
    setActivateMenu(true);
    setAnchorEl(event.currentTarget);
  }
  const handleEmailClose = () => {
    setAnchorEl(null);
    setActivateMenu(false);
  }
  const handleSendMail = () => {
    window.open(`mailto:${currentEmail}`, '_blank');
    handleEmailClose();
    setAnchorEl(null)
    setActivateMenu(false);
    setAnchorEl(null);

  };
  const handleEditEmail = () => {
    setCurrentEmail((prev) => { return { ...prev, isActive: true } })
    handleEmailClose();
  };

  const handleSnackbarClose = () => {
    setErrorSnackbar(false);
    setOpenSnackbar(false);
  };

  const handleStatusClick = async (e, id = "") => {
    e.preventDefault();
    e.stopPropagation();

    if (id === 'candidate_review') {
      try {
        const response = await axiosInstance.post(
          `${END_POINTS.SHARE_CANDIDATE}`,
          { userId, email: candidateReview.value, candidateId: candidate._id },
        //  { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );

        setOpenSnackbar(true)
        setMessage('Candidate shared successfully')

        setCandidateReview((prev) => ({ ...prev, isActive: false }));
      } catch (error) {
        const status = error?.response?.status;
        const message = error?.response?.data?.message;
        const sharedBy = error?.response?.data?.sharedBy;
        const sameRecruiter = error?.response?.data?.sameRecruiter;

        if (status === 409) {
          if (sameRecruiter) {
            setOpenSnackbar(true);
            setMessage('You already shared this candidate with this panelist.')
            setErrorSnackbar(true)

          } else {
            setOpenSnackbar(true);
            setMessage(`Candidate already shared with this panelist by ${sharedBy}`)
            setErrorSnackbar(true)
          }
        } else if (status === 404) {
          setOpenSnackbar(true);
          setMessage(`Panelist not found. Please check the email.`)
          setErrorSnackbar(true)
        } else if (status === 400) {
          setOpenSnackbar(true);
          setMessage(`Missing candidate ID or email.`)
          setErrorSnackbar(true)
        } else {
          setOpenSnackbar(true);
          setMessage(`Failed to share candidate: ${message || 'Unknown error'}`)
          setErrorSnackbar(true)

        }
      }
    }
    else {

      const actions = {
        changeStatus: { key: 'status', value: application_status },
        changeRole: { key: 'applied_position', value: applied_position },
        remarks: { key: 'remarks', value: formValue },
        expectedCtc: { key: 'expectedCtc', value: `${expectedCtc?.value}` },
        currentCtc: { key: 'currentCtc', value: `${currentCtc?.value}` },
        relocate: { key: 'relocate', value: relocate?.value },
        noticePeriod: { key: 'noticePeriod', value: `${noticePeriod?.value}`.toUpperCase() },
        releventExp: { key: 'releventExp', value: `${releventExp?.value}` },
        currentOrganisation: { key: 'currentOrganisation', value: currentOrg?.value },
        email: { key: 'email', value: currentEmail?.value },
        location: { key: 'location', value: currentLocation?.value },
        education: { key: 'education', value: currentEducation?.value },
        phone_number: { key: 'phone_number', value: currentPhone?.value },
        experience: { key: 'experience', value: currentExp?.value },
        name: { key: 'name', value: currentName?.value }
      };

      const action = actions[e.target.id];
      if (!action) return;
      const { key, value } = action;
      const loaders = {
        name: (bool) => setCurrentName((prev) => ({ ...prev, isLoading: bool })),
        status: setStatusLoader,
        applied_position: setRoleLoader,
        remarks: setRemarksLoader,
        currentCtc: (bool) => setCurrentCtc((prev) => ({ ...prev, isLoading: bool })),
        expectedCtc: (bool) => setExpectedCtc((prev) => ({ ...prev, isLoading: bool })),
        relocate: (bool) => setRelocate((prev) => ({ ...prev, isLoading: bool })),
        noticePeriod: (bool) => setNoticePeriod((prev) => ({ ...prev, isLoading: bool })),
        releventExp: (bool) => ((prev) => setReleventExp({ ...prev, isLoading: bool })),
        currentOrganisation: (bool) => setCurrentOrg((prev) => ({ ...prev, isLoading: bool })),
        email: (bool) => setCurrentEmail((prev) => ({ ...prev, isLoading: bool })),
        location: (bool) => setCurrentLocation((prev) => ({ ...prev, isLoading: bool })),
        phone_number: (bool) => setCurrentPhone((prev) => ({ ...prev, isLoading: bool })),
        education: (bool) => setCurrentEducation((prev) => ({ ...prev, isLoading: bool })),
        experience: (bool) => setCurrentExp((prev) => ({ ...prev, isLoading: bool }))
      };

      if (loaders[key]) loaders[key](true);

      try {
        const response = await axiosInstance.post(
          `${END_POINTS.CANDIDATE}/${candidate._id}`,
          { key, value },
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        const data = response.data;
        const fieldStateUpdates = {
          name: (prev) => {
            setCurrentName({ ...prev, value: data.name, isActive: false });
            setOpenSnackbar(true);
            setMessage('Name Succesfully Edited')
          },
          status: () => {
            setStatus(data.status);
            setIsStatusClose(true);
            setOpenSnackbar(true);
            setMessage('Status Successfully Edited')
            setApplication_status('')
          },
          applied_position: () => {
            setRole(data.applied_position);
            setIsRoleClose(true);
            setOpenSnackbar(true);
            setMessage('Applied Position Successfully Edited')
            setApplied_position('');
          },
          remarks: () => {
            setIsEditRemarksOpen(false);
            setOpenSnackbar(true);
            setMessage('Remarks Successfully Edited')
          },
          currentCtc: (prev) => {
            setCurrentCtc({ ...prev, value: data.currentCtc, isActive: false })
            setOpenSnackbar(true);
            setMessage('Current CTC Successfully Edited')
          },
          expectedCtc: (prev) => {
            setExpectedCtc({ ...prev, value: data.expectedCtc, isActive: false });
            // setIsExpectedCtcActive(false);
            setOpenSnackbar(true);
            setMessage('Expected CTC Successfully Edited')

          },
          relocate: (prev) => {
            setRelocate({ ...prev, value: data.relocate, isActive: false });
            // setIsRelocateActive(false);
            setOpenSnackbar(true);
            setMessage('Reloction Successfully Edited')

          },
          noticePeriod: (prev) => {
            setNoticePeriod({ ...prev, value: data.noticePeriod, isActive: false });
            // setIsNoticePeriodActive(false);
            setOpenSnackbar(true);
            setMessage('Notice Period Successfully Edited')
          },
          releventExp: (prev) => {
            setReleventExp((prev) => { return { ...prev, value: data.releventExp, isActive: false } });
            // setIsReleventExpActive(false);
            setOpenSnackbar(true);
            setMessage('Relevant Experience Successfully Edited')
          },
          currentOrganisation: (prev) => {
            setCurrentOrg((prev) => { return { ...prev, value: data.currentOrganisation, isActive: false } });
            // setIsCurrentOrgActive(false);
            setOpenSnackbar(true);
            setMessage('Current Organisation Successfully Edited')
          },
          email: (prev) => {
            setCurrentEmail((prev) => { return { ...prev, value: data.email, isActive: false } });
            setAnchorEl(null);
            setActivateMenu(false);
            // setIsCurrentEmailActive(false);
            setOpenSnackbar(true);
            setMessage('Email Successfully Edited')

          },
          location: (prev) => {
            setCurrentLocation({ ...prev, value: data.location, isActive: false });
            //  setIsCurrentLocationActive(false);
            setOpenSnackbar(true);
            setMessage('Location Successfully Edited')
          },
          phone_number: (prev) => {
            setCurrentPhone({ ...prev, value: data.phone_number, isActive: false });
            // setIsCurrentPhoneActive(false);
            setOpenSnackbar(true);
            setMessage('Phone Number Successfully Edited')
          },
          education: (prev) => {
            setCurrentEducation({ ...prev, value: data.education, isActive: false });
            // setIsCurrentEducationActive(false);
            setOpenSnackbar(true);
            setMessage('Education Successfully Edited')
          },
          experience: (prev) => {
            setCurrentExp({ ...prev, value: data.experience, isActive: false });
            //setIsCurrentExpActive(false);
            setOpenSnackbar(true);
            setMessage('Total Experience Successfully Edited')
          }
        };
        // Execute the state update for the appropriate field
        if (fieldStateUpdates[key]) {
          fieldStateUpdates[key]();
        }
        // Reset the loader after the update
        if (loaders[key]) loaders[key](false);
        navigate(`${END_POINTS.CANDIDATE}/${data.updatedData._id}`, {
          state: { candidate: data.updatedData }
        });
      } catch (error) {
        console.error('Error editing candidate:', error);
      }
    }
  };

  const handleDropdownClose = (e) => {
    if (e.target.id === "changeRole") {
      setIsRoleClose(true)
    }
    if (e.target.id === "changeStatus") {
      setIsStatusClose(true)
    }
  }

  const ResumeViewer = ({ base64Data }) => {
    return (
      <iframe
        src={base64Data}
        title="Resume PDF"
        width="100%"
        height="600px"
        style={{ border: 'none' }}
      ></iframe>
    );
  }

  const downloadFile = async () => {
    setIsViewResume(prev => !prev);
  };

  const handleCancelRemarks = () => {
    setFormValue(candidate.remarks);
    setIsEditRemarksOpen(false)
  }

const handleViewResume = async () => {
  const response = await axiosInstance.get(`/download/${candidate._id}`, {
    responseType: "blob"
  });

  const mimeType = response.data.type;

  if (mimeType === "application/pdf") {
    const url = window.URL.createObjectURL(response.data);
    setPdfURL(url);
  } else {
    // DOCX or anything else
    const url = window.URL.createObjectURL(response.data);
    window.open(url);
  }
};


  const handleFileUpload = () => {
    setOpenUploadFile(true)
    setIsViewResume(false)
  }


  const handleDownloadResume = async () => {
  try {
    const response = await axiosInstance.get(`/download/${candidate._id}`, {
      responseType: 'blob', 
    });

    const blob = response.data;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = candidate?.resume?.resumeName || 'resume.pdf';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error downloading the resume:", error);
    setOpenSnackbar(true);
    setMessage('Sorry, failed to download resume');
  }
  setIsViewResume(false);
};

  const handleInterviewClose = () => {
    setOpen(false)
  }

  const handleDeleteSingleCandidate = async () => {
    if (window.confirm("Are you sure you want to delete this profile?")) {
      try {
        await axiosInstance.post(`${END_POINTS.CANDIDATE}/${candidate._id}/delete`,
          null,
          { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }
        );
        alert("Profile deleted successfully.");
        navigate("/candidatelist");
      } catch (error) {
        console.error("Error deleting profile: front", error.message);
        alert("Failed to delete profile.");
      }
    }
  };
  const formCtc = (id, stateDetails, setStateDetails) => {
    const activeStatus = () => {
      if (id === "email") {
        setAnchorEl(null);
        handleEmailClose();
        setStateDetails({ ...stateDetails, isActive: false })
      } else {
        setStateDetails({ ...stateDetails, isActive: false });
      }
    };
    const extraProps = id === 'experience' ? { step: "any", min: 0 } : {};

    return (
      <form
        onSubmit={(e) => handleStatusClick(e, id)}
        id={id}
        className="flex flex-wrap items-center gap-2 mt-1 max-w-full"
      >
        <input
          type={id === 'experience' ? "number" : "text"}
          {...extraProps}
          value={stateDetails.value}
          onChange={(e) =>
            setStateDetails({ ...stateDetails, value: e.target.value })
          }
          className={`${id === "name" || id === 'email' || id === 'phone_number' || id === 'location' || id === 'education' || id === 'candidate_review' || id === "currentOrganisation"
            ? 'w-auto'
            : 'w-[60px]'
            } p-1 bg-white border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-300`}
          id={id}
          required
        />

        <button
          type="submit"
          className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition"
        >
          {id === 'candidate_review' ? 'Send' : 'Save'}
        </button>

        <button
          type="button"
          onClick={activeStatus}
          className="p-1 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition"
        >
          Cancel
        </button>
      </form>
    );

  };

return (
    <>
      {openLoader ? (
        <Backdrop
          sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}
          open={openLoader}
          onClick={handleCloseLoader}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <>
          {/* Main Container */}
          <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 p-4 md:p-6 overflow-hidden">
            <SnackbarComponent 
              open={openSnackbar} 
              handleClose={handleSnackbarClose} 
              message={message} 
              alertError={errorSnackbar} 
            />

            {/* Header Card - Profile Information */}
           <Card className="mb-6 shadow-lg border-0 bg-gradient-to-r from-white to-blue-50">
  <CardContent className="p-2 md:p-3">
    <div className="flex flex-col lg:flex-row items-center lg:items-start gap-2 lg:gap-3">
      
      {/* Profile Image Section - More Compact */}
      <div className="flex flex-col items-center gap-2">
  <Avatar 
    src="/Profile.svg" 
    alt="Candidate Photo"
    className="w-24 h-24 md:w-24 md:h-24 shadow-lg border-2 border-white"
  />
  
  {user?.role === 'admin' && (
    <div className="flex flex-col gap-1 justify-center items-center w-full max-w-[120px]">
      <Button 
        variant="contained"
        color="error" 
        size="small"
        startIcon={<DeleteIcon className="w-3 h-3" />}
        onClick={handleDeleteSingleCandidate}
        className="text-xs px-2 py-1 h-6 w-full"
      >
        Delete
      </Button>
      <Button 
        variant="contained"
        color="warning" 
        size="small"
        startIcon={<CalendarTodayIcon className="w-3 h-3" />}
        onClick={() => setOpen(true)}
        className="text-xs px-2 py-1 h-6 w-full"
      >
        Schedule
      </Button>
    </div>
  )}
</div>


      {/* Main Profile Info - Horizontal Grid */}
      <div className="flex-1 w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-1 md:gap-2">

         {/* Main Profile Info - Vertical Stack */}
<div className="flex-1 space-y-2 w-full">
  {/* Name */}
  <div className="flex items-center gap-1">
    <PersonIcon className="text-blue-600 w-4 h-4" />
    <div className="flex-1 min-h-[24px]">
     <EditableField 
        id="name" 
        title="name" 
        value={currentName.value}
        defaultValue={!currentName.value?.trim() && candidate?.name && candidate?.name !== 'N/A' ? candidate.name : 'Add Name'}
        candidateValue={candidate?.name} 
        isActive={currentName.isActive} 
        setIsActive={setCurrentName}
        isLoading={currentName.isLoading} 
        canEdit={isAdmin}
        formComponent={formCtc("name", currentName, setCurrentName)} 
      /> 
    </div>
  </div>

  {/* Organization */}
  <div className="flex items-center gap-1">
    <CorporateFareIcon className="text-green-600 w-4 h-4" />
    <div className="flex-1 min-h-[24px]">
      <EditableField 
        id="currentOrganisation" 
        title="Organisation" 
        value={currentOrg.value}
        defaultValue={!currentOrg.value?.trim() && candidate?.currentOrganisation && candidate?.currentOrganisation !== 'N/A' ? candidate?.currentOrganisation : 'Add Organisation'}
        candidateValue={candidate?.organisation} 
        isActive={currentOrg.isActive} 
        setIsActive={setCurrentOrg}
        isLoading={currentOrg.isLoading} 
         canEdit={isAdmin}
        formComponent={formCtc("currentOrganisation", currentOrg, setCurrentOrg)} 
      />
    </div>
  </div>

  {/* Education */}
  <div className="flex items-center gap-1">
    <SchoolIcon className="text-purple-600 w-4 h-4" />
    <div className="flex-1 min-h-[24px]">
      <EditableField 
        id="education" 
        title="Education" 
        value={currentEducation.value}
        defaultValue={!currentEducation.value?.trim() && candidate?.education && candidate?.education !== 'N/A' ? candidate?.education : 'Add Education'}
        candidateValue={candidate?.education} 
        isActive={currentEducation.isActive} 
        setIsActive={setCurrentEducation}
        isLoading={currentEducation.isLoading} 
         canEdit={isAdmin}
        formComponent={formCtc("education", currentEducation, setCurrentEducation)} 
      />
    </div>
  </div>

  {/* Experience */}
  <div className="flex items-center gap-1">
    <WorkIcon className="text-orange-600 w-4 h-4" />
    <div className="flex-1 min-h-[24px]">
      <EditableField 
        id="experience" 
        suffix=" years" 
        title="Experience" 
        value={currentExp.value}
        defaultValue={(currentExp.value === null || currentExp.value === '') && candidate?.experience && candidate?.experience !== 'N/A' ? candidate?.experience : 'Add experience'}
        candidateValue={candidate?.experience} 
        isActive={currentExp.isActive} 
        setIsActive={setCurrentExp}
        isLoading={currentExp.isLoading} 
         canEdit={isAdmin}
        formComponent={formCtc("experience", currentExp, setCurrentExp)} 
      />
    </div>
  </div>
</div>

         
        </div>
      </div>

      {/* Contact Information - Horizontal Grid Layout */}
      <div className="w-full lg:w-auto lg:min-w-[300px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-1">
          
          {/* Share for Review */}
        {user?.role==='admin' &&  <div className="flex items-center gap-1 p-1.5 bg-green-50 rounded">
            <IosShareIcon className="text-green-600 w-4 h-4 flex-shrink-0" />
            <div className="flex-1 min-w-0 min-h-[24px]">
              <EditableField 
                id="candidate_review" 
                classname="text-green-600 text-xs" 
                title="candidateReview" 
                value={candidateReview.value} 
                defaultValue="Send For review"
                candidateValue="" 
                isActive={candidateReview.isActive} 
                setIsActive={setCandidateReview}
                isLoading={candidateReview.isLoading} 
                 canEdit={isAdmin}
                formComponent={formCtc("candidate_review", candidateReview, setCandidateReview)} 
              />
            </div>
          </div>}

          {/* Email */}
          { (
            <div className="flex items-center gap-1 p-1.5 bg-blue-50 rounded">
              <MailIcon className="text-blue-600 w-4 h-4 flex-shrink-0" />
              <div className="flex-1 min-w-0 min-h-[24px]">
                <EditableField 
                  id="email" 
                  title="Email" 
                  value={currentEmail.value}
                  defaultValue={candidate?.email === 'N/A' && !currentEmail?.value.trim() && candidate?.email ? candidate?.email : 'Add Email'}
                  candidateValue={candidate?.email} 
                  isActive={currentEmail.isActive} 
                  setIsActive={setCurrentEmail}
                  isLoading={currentEmail.isLoading} 
                  formComponent={formCtc("email", currentEmail, setCurrentEmail)}
                   canEdit={isAdmin}
                  onClickOverride={handleEmailClick}
                  extraMenu={
                    <Menu
                      anchorEl={anchorEl}
                      open={activateMenu}
                      onClose={handleEmailClose}
                      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                      PaperProps={{
                        className: "shadow-lg border border-gray-200"
                      }}
                    >
                      <MenuItem 
                        onClick={handleSendMail} 
                        className="flex items-center gap-2 px-2 py-1 hover:bg-blue-50 text-xs min-h-[28px]"
                      >
                        
                        <MailIcon className="text-blue-600 w-4 h-4" />
                        Send Email
                      </MenuItem>
                      <MenuItem 
                        onClick={handleEditEmail} 
                        className="flex items-center gap-2 px-2 py-1 hover:bg-yellow-50 text-xs min-h-[28px]"
                      >
                        <EditIcon className="text-yellow-600 w-4 h-4" />
                        Change Email
                      </MenuItem>
                    </Menu>
                  }
                />
              </div>
            </div>
          )}

          {/* Phone */}
          <div className="flex items-center gap-1 p-1.5 bg-purple-50 rounded">
            <LocalPhoneIcon className="text-purple-600 w-4 h-4 flex-shrink-0" />
            <div className="flex-1 min-w-0 min-h-[24px]">
              <EditableField 
                id="phone_number" 
                title="Phone" 
                value={currentPhone.value}
                defaultValue={candidate?.phone_number === 'N/A' && !currentPhone?.value?.trim() && candidate?.phone_number ? candidate?.phone_number : 'Add Phone'}
                candidateValue={candidate?.phone_number} 
                isActive={currentPhone.isActive} 
                setIsActive={setCurrentPhone}
                isLoading={currentPhone.isLoading} 
                 canEdit={isAdmin}
                formComponent={formCtc("phone_number", currentPhone, setCurrentPhone)} 
              />
            </div>
          </div>

          {/* Location */}
          <div className="flex items-center gap-1 p-1.5 bg-red-50 rounded">
            <LocationOnIcon className="text-red-600 w-4 h-4 flex-shrink-0" />
            <div className="flex-1 min-w-0 min-h-[24px]">
              <EditableField 
                id="location" 
                title="Location" 
                value={currentLocation.value}
                defaultValue={candidate?.location === 'N/A' && !currentLocation?.value.trim() && candidate?.location ? candidate?.location : 'Add Location'}
                candidateValue={candidate?.location} 
                isActive={currentLocation.isActive} 
                setIsActive={setCurrentLocation}
                isLoading={currentLocation.isLoading} 
                 canEdit={isAdmin}
                formComponent={formCtc("location", currentLocation, setCurrentLocation)} 
              />
            </div>
          </div>

          {/* Resume */}
          <div className="sm:col-span-2 lg:col-span-1 xl:col-span-2 flex items-center gap-1 p-1.5 bg-indigo-50 rounded relative">
  <PictureAsPdfIcon className="text-indigo-600 w-4 h-4 flex-shrink-0" />
  <p
    className="text-indigo-700 cursor-pointer font-medium hover:text-indigo-800 transition-colors text-xs truncate flex-1"
    onClick={openResumeMenu}  
  >
    {resume?.resumeName || 'No Resume'}
  </p>

  
  <Menu
    anchorEl={resumeMenuAnchor}
    open={Boolean(resumeMenuAnchor)}
    onClose={closeResumeMenu}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
    keepMounted
  >
    <MenuItem onClick={() => { handleViewResume(); closeResumeMenu(); }}>
      View Resume
    </MenuItem>
    <MenuItem onClick={() => { setIsFormattedResumeOpen(true); closeResumeMenu(); }}>
  View Formatted Resume
</MenuItem>
  { isAdmin && <MenuItem onClick={() => { setOpenUploadFile(true); closeResumeMenu(); }}>
      Update Resume
    </MenuItem>}
    <MenuItem onClick={() => { handleDownloadResume(); closeResumeMenu(); }}>
      Download Resume
    </MenuItem>
  </Menu>
</div>

        </div>
      </div>
    </div>
  </CardContent>
</Card>
 <FormattedResumeModal
  open={isFormattedResumeOpen}
  onClose={() => setIsFormattedResumeOpen(false)}
  candidate={candidate}
/>

            {/* Resume and Upload Modals */}
            <Modal open={!!pdfURL} onClose={() => setPdfURL('')}>
              <Box sx={styleModal} className="scrollbar-thin scrollbar-rounded overflow-y-scroll">
                <ResumeViewer base64Data={pdfURL} />
              </Box>
            </Modal>

            <Modal open={openUploadFile} onClose={() => setOpenUploadFile(false)}>
              <Box sx={style}>
                {isCircularProgress && <CircularProgress />}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h6">Upload File</Typography>
                  <IconButton onClick={() => setOpenUploadFile(false)}>
                    <CloseIcon />
                  </IconButton>
                </Box>
                <Box mt={3}>
                  <Button variant="contained" component="label">
                    Select File
                    <input type="file" hidden onChange={handleFileChange} />
                  </Button>
                  <Typography mt={1} variant="body2">
                    {selectedFile ? selectedFile.name : "No file selected"}
                  </Typography>
                </Box>
                <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
                  <Button onClick={() => setOpenUploadFile(false)}>Cancel</Button>
                  <Button variant="contained" onClick={handleUpload} disabled={!selectedFile}>Upload</Button>
                </Box>
              </Box>
            </Modal>

            {/* Content Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
              
              {/* Left Column */}
              <div className="lg:col-span-2 space-y-6">
                
                {/* Profile Description */}
                <Card className="shadow-lg border-0">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-1 h-6 bg-gradient-to-b from-blue-500 to-purple-500 rounded-full"></div>
                      <Typography variant="h5" className="font-bold text-gray-800">
                        Candidate Description
                      </Typography>
                    </div>
                    <Typography variant="body1" className="text-gray-700 leading-relaxed">
                      {profileSummary}
                    </Typography>
                  </CardContent>
                </Card>

                {/* Professional Details */}
               {user?.role === 'admin' && (
  <Card className="shadow-lg border-0">
    <CardContent className="p-4">
      <div className="flex items-center gap-2 mb-4">
        <div className="w-1 h-4 bg-gradient-to-b from-green-500 to-blue-500 rounded-full"></div>
        <Typography variant="h6" className="font-bold text-gray-800">
          Professional Details
        </Typography>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {[
          ["Current CTC", "currentCtc", currentCtc, candidate?.currentCtc, setCurrentCtc],
          ["Expected CTC", "expectedCtc", expectedCtc, candidate?.expectedCtc, setExpectedCtc],
          ["Ready to relocate", "relocate", relocate, candidate?.Relocate, setRelocate],
          ["Notice Period", "noticePeriod", noticePeriod, candidate?.NoticePeriod, setNoticePeriod],
          [`Relevant Experience as ${role}`, "releventExp", releventExp, candidate?.ReleventExp, setReleventExp]
        ].map(([label, id, state, value, setter], idx) => {
          const defaultVal = value === 'N/A' || (typeof state?.value === 'string' && state?.value.trim() !== '') ? 'Add' : value;

          return (
            <div key={idx} className="bg-gray-50 p-2 rounded-md">
              <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1">
                <span className='font-medium text-gray-700 text-sm'>{label}:</span>
                <div className="flex-1 sm:text-right min-h-[28px]">
                <EditableField
                    id={id}
                    title={label}
                    value={state.value}
                    defaultValue={defaultVal}
                    candidateValue={value}
                    isActive={state.isActive}
                    setIsActive={setter}
                    isLoading={state.isLoading}
                    formComponent={formCtc(id, state, setter)}
                     canEdit={isAdmin}
                    professionalDetails={true}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </CardContent>
  </Card>
)}


                {/* Interview Details */}
                <Card className="shadow-lg border-0">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-1 h-6 bg-gradient-to-b from-purple-500 to-pink-500 rounded-full"></div>
                      <Typography variant="h5" className="font-bold text-gray-800">
                        Interview Details
                      </Typography>
                    </div>
                    <InterviewComponent
                      candidate={candidate}
                      setCandidate={setCandidate}
                      handleInterviewClose={handleInterviewClose}
                      open={open}
                      setOpen={setOpen}
                    />
                  </CardContent>
                </Card>
              </div>

              {/* Right Column */}
              <div className="space-y-6">
                
                {/* Skills */}
                <Card className="shadow-lg border-0">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-1 h-6 bg-gradient-to-b from-yellow-500 to-orange-500 rounded-full"></div>
                      <Typography variant="h5" className="font-bold text-gray-800">
                        Skills
                      </Typography>
                    </div>
                    <div className="flex flex-wrap gap-2">
                      {Array.isArray(skills) && skills.map((skill, index) => (
                        <Chip 
                          key={index} 
                          label={skill}
                          className="bg-gradient-to-r from-blue-300 to-purple-200 text-white font-medium shadow-sm hover:shadow-md transition-shadow"
                          size="small"
                        />
                      ))}
                    </div>
                  </CardContent>
                </Card>

                {/* Role and Status */}
                <Card className="shadow-lg border-0">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-3 mb-6">
                      <div className="w-1 h-6 bg-gradient-to-b from-red-500 to-pink-500 rounded-full"></div>
                      <Typography variant="h5" className="font-bold text-gray-800">
                        Status & Role
                      </Typography>
                    </div>
                    
                    <div className="space-y-4">
                      <div className="bg-blue-50 p-4 rounded-lg">
                        <Typography variant="h6" className="text-blue-800 font-semibold mb-2">
                          Applied Role:
                        </Typography>
                        <Typography variant="body1" className="text-blue-700">
                          {roleLoader ? <CircularLoader /> : role}
                        </Typography>
                      </div>
                      
                      <div className="bg-green-50 p-4 rounded-lg">
                        <Typography variant="h6" className="text-green-800 font-semibold mb-2">
                          Application Status:
                        </Typography>
                        <Typography variant="body1" className="text-green-700">
                          {statusLoader ? <CircularLoader /> : status}
                        </Typography>
                      </div>

                      {user.role === 'admin' && (
                        <div className="flex flex-col gap-3 pt-4">
                          {isRoleClose && (
                            isStatusClose ? (
                              <Button 
                                color="warning" 
                                variant="contained" 
                                onClick={handleClose} 
                                id="changeStatus"
                                className="w-full"
                              >
                                Edit Status
                              </Button>
                            ) : (
                              <div className="flex flex-col gap-2">
                                <Dropdown dropdown="applicantStatus" />
                                <div className="flex gap-2">
                                  <Button 
                                    variant="contained" 
                                    color="primary" 
                                    onClick={handleStatusClick} 
                                    id="changeStatus"
                                    className="flex-1"
                                  >
                                    Save
                                  </Button>
                                  <Button 
                                    variant="outlined" 
                                    color="secondary" 
                                    onClick={(e) => {
                                      if (e.target.id === "changeStatus") {
                                        setIsStatusClose(true)
                                      }
                                    }} 
                                    id="changeStatus"
                                    className="flex-1"
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            )
                          )}
                          
                          {isStatusClose && (
                            isRoleClose ? (
                              <Button 
                                color="info" 
                                variant="contained" 
                                onClick={handleClose} 
                                id="changeRole"
                                className="w-full"
                              >
                                Change Role
                              </Button>
                            ) : (
                              <div className="flex flex-col gap-2">
                                <Dropdown dropdown="addProfile" changeRole={true} />
                                <div className="flex gap-2">
                                  <Button 
                                    variant="contained" 
                                    color="primary" 
                                    onClick={handleStatusClick} 
                                    id="changeRole"
                                    className="flex-1"
                                  >
                                    Save
                                  </Button>
                                  <Button 
                                    variant="outlined" 
                                    color="secondary" 
                                    onClick={(e) => {
                                      if (e.target.id === "changeRole") {
                                        setIsRoleClose(true)
                                      }
                                    }} 
                                    id="changeRole"
                                    className="flex-1"
                                  >
                                    Cancel
                                  </Button>
                                </div>
                              </div>
                            )
                          )}
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>

                {/* Remarks */}
                <Card className="shadow-lg border-0">
                  <CardContent className="p-6">
                    <div className="flex items-center gap-3 mb-4">
                      <div className="w-1 h-6 bg-gradient-to-b from-indigo-500 to-blue-500 rounded-full"></div>
                      <Typography variant="h5" className="font-bold text-gray-800">
                        Remarks
                      </Typography>
                    </div>
                    
                    {!candidate.remarks || isEditRemarksOpen ? (
                      <form onSubmit={handleStatusClick} className="w-full" id="remarks">
                        <textarea
                          className="w-full p-4 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent bg-gray-50 focus:bg-white transition-colors min-h-[120px] resize-none"
                          rows={4}
                          placeholder="Add your remarks here..."
                          value={formValue}
                          onChange={(e) => setFormValue(e.target.value)}
                        />
                        <div className='flex justify-end mt-3 gap-2'>
                          <Button 
                            variant="contained" 
                            type="submit" 
                            className='bg-blue-600 hover:bg-blue-700 text-white'
                          >
                            Save Remarks
                          </Button>
                          <Button 
                            variant="outlined" 
                            className='text-red-600 border-red-600 hover:bg-red-50' 
                            onClick={handleCancelRemarks}
                          >
                            Cancel
                          </Button>
                        </div>
                      </form>
                    ) : (
                      <div className="bg-gray-50 p-4 rounded-lg">
                        <Typography variant="body1" className="text-gray-700 mb-2">
                          {formValue}
                        </Typography>
                        <Button
                          variant="text"
                          size="small"
                          className="text-blue-600 hover:text-blue-800"
                          onClick={() => setIsEditRemarksOpen(true)}
                          startIcon={<EditIcon />}
                        >
                          Edit Remarks
                        </Button>
                      </div>
                    )}
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}